import React from 'react'
import PartnersLogoImages from "../../../Assets/Images/imgPartnersLogoBPN.png"

const OurPartnersBPN = () => {
    return (
        <>
            <section className='OurPartners-section '>
                <div className='text-center'>
                    <h2 >Our Partners</h2>
                </div>
                <div className='text-center mt-4 container'>
                    <img src={PartnersLogoImages} alt='logoImage' style={{width:"100%"}}/>
                </div>
            </section>
        </>
    )
}

export default OurPartnersBPN